import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import styled, { css } from "styled-components";
export var IssueTopicCardButtonWrapper = styled(Button).withConfig({
  displayName: "styles__IssueTopicCardButtonWrapper"
})(["border-radius:4px;padding:", ";cursor:pointer;text-align:left;border:", ";background-color:", ";&:hover{border:1px solid ", ";background-color:", ";}min-width:148px;width:100%;height:auto;"], getSpacing("2x"), function (props) {
  return props.$isSelected ? css(["1px solid ", ""], Core.border["default"]) : css(["1px solid ", ""], Core.border.muted);
}, function (props) {
  return props.$isSelected ? Core.surface.muted : Core.surface.inverse;
}, Core.border["default"], Core.surface.inverse);
export var IssueTopicCardInnerWrapper = styled(Column).withConfig({
  displayName: "styles__IssueTopicCardInnerWrapper"
})(["width:100%;flex-wrap:wrap;"]);
export var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper"
})(["width:24px;height:24px;text-align:center;& svg{color:", " !important;}"], Core.icon.subdued);
export var TypographyWrapper = styled(Typography).attrs({
  variant: "paragraphSansMedium"
}).withConfig({
  displayName: "styles__TypographyWrapper"
})(["&&&{color:", " !important;}"], Core.text["default"]);